/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Archive_Back_To_AppInputs */

const en_newsletter_archive_back_to_app = /** @type {(inputs: Newsletter_Archive_Back_To_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to portfolio`)
};

/**
* | output |
* | --- |
* | "Back to portfolio" |
*
* @param {Newsletter_Archive_Back_To_AppInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_archive_back_to_app = /** @type {((inputs?: Newsletter_Archive_Back_To_AppInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Archive_Back_To_AppInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_archive_back_to_app(inputs)
});